import React from "react";
import {SalesPackageOption} from "../../../../components/SalesPackage/SalesPackageOption";
import {SalesPackage} from "../../../../components/SalesPackage";
import {VehicleGroup} from "../../../../model/vehicle";
import {strings} from "../../../../strings/strings";
import useSwitchToNewContent from "../../../../utils/hooks/useSwitchToNewContent";

interface BaseSmartDrivePackage {
    vehicleGroup: VehicleGroup;
    premium: number;
    totalPremium: number;
    selected: boolean;
    onSelect: () => void;
    packageName: string;
    more?: React.ReactElement;
}

export const BaseSmartDrivePackage = (props: BaseSmartDrivePackage) => {
    const {premium, selected, onSelect, vehicleGroup, packageName, more, totalPremium} = props;
    const showNewContent = useSwitchToNewContent()

    return (
        <SalesPackage name={packageName}
                      premium={premium}
                      totalPremium={totalPremium}
                      selected={selected}
                      onSelect={onSelect}
                      popular={true}
                      vehicleGroup={vehicleGroup}
                      more={more}
                      isSmartDrive
                      >
            <SalesPackageOption name={strings.packageOptionMtplName}
                                tooltipPlacement={"left"}
                                tooltip={<ul>
                                    <li>{showNewContent ? strings.packageOptionMtplText1in2025 : strings.packageOptionMtplText1}</li>
                                    <li>{showNewContent ? strings.packageOptionMtplText2in2025 : strings.packageOptionMtplText2}</li>
                                </ul>}
                                covered={true}/>
        </SalesPackage>
    )

};